import React from "react";
import { Link, useParams } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";

// Import Images
import error500 from "../../../assets/images/error500.png";

const Error500 = () => {
  document.title = "Error | Ordering Management System";
  const { orgcode } = useParams();
  return (
    <React.Fragment>
      <div className="auth-page-wrapper bg-dark py-5 d-flex justify-content-center align-items-center min-vh-100">
        <div className="auth-page-content overflow-hidden p-0">
          <Container fluid={true} className="">
            <Row className="justify-content-center ">
              <Col xl={6} className="text-center ">
                <div className="error-500 position-relative">
                  <img
                    src={error500}
                    alt=""
                    className="img-fluid error-500-img error-img"
                  />
                  <h1 className="title text-muted">Oops!</h1>
                </div>
                <div >
                  <h3 className="text-light"> Invalid Organization</h3>
                  <p className="text-light w-75 mx-auto">
                    The organization code{" "}
                    <strong className="text-light">{orgcode || ""}</strong> is
                    not registered or has no theme assigned.
                  </p>
                  <Link to="/login" className="btn btn-success">
                    <i className="mdi mdi-home me-1"></i>Back to Login
                  </Link>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Error500;
